/**
 * Core TMS modules super admin can enable/disable (global + per tenant).
 * Matches server TENANT_ASSIGNABLE_CORE_KEYS.
 */
export const ASSIGNABLE_CORE_MODULE_ITEMS = [
  { key: 'trips', label: 'Trips', description: 'Plan and track trips' },
  { key: 'bilty', label: 'Bilty (LR)', description: 'Bilty, goods names, senders, receivers and bills' },
  { key: 'clients', label: 'Clients', description: 'Client list' },
  { key: 'vehicles', label: 'Vehicles', description: 'Vehicles, types, brands and models' },
  { key: 'gps_tracking', label: 'Live Map (GPS)', description: 'Live map, GPS boxes, alerts and reports' },
  { key: 'drivers', label: 'Drivers', description: 'Driver list' },
  { key: 'helpers', label: 'Helpers', description: 'Helper list' },
  { key: 'fuel', label: 'Fuel', description: 'Fuel fill records' },
  { key: 'maintenance', label: 'Service / Repair', description: 'Vehicle service and repair' },
  { key: 'puncture', label: 'Puncture', description: 'Puncture repair records' },
  { key: 'cash_memo', label: 'Cash Book', description: 'Daily cash in and cash out' },
  { key: 'fastag', label: 'FASTag', description: 'FASTag balance and trips' },
  { key: 'battery_maintenance', label: 'Battery', description: 'Battery change or charge' },
  { key: 'documents', label: 'Documents', description: 'Documents with expiry alerts' },
  { key: 'reports', label: 'Reports', description: 'Ready reports' },
  { key: 'branches', label: 'Branches', description: 'Office / branch locations' },
  { key: 'roles', label: 'Staff & Login', description: 'Who can login and what they can do' },
] as const;

/** System modules — always on, not toggled in Core Modules or Tenant Access */
export const SYSTEM_ALWAYS_ON_MODULES = [
  { key: 'dashboard', label: 'Home' },
  { key: 'settings', label: 'Settings' },
] as const;
